export default "__VITE_ASSET__C$vHziQN__"